import PG1 from './pg1';
export default PG1;